import React from "react";
import { Target, Trophy, Flame, Zap, Rocket, Award, BookOpen } from "lucide-react";

export const BADGES = {
  first_practice: { label: "First Steps", desc: "Complete your first practice", icon: Target, color: "bg-sky text-white" },
  perfect_score: { label: "Perfectionist", desc: "Score 100% on any exercise", icon: Trophy, color: "bg-lemon text-ink" },
  streak_3: { label: "On Fire", desc: "3-day practice streak", icon: Flame, color: "bg-watermelon text-white" },
  streak_7: { label: "Blazing", desc: "7-day practice streak", icon: Zap, color: "bg-grape text-white" },
  speed_demon: { label: "Speed Demon", desc: "Finish under 3 minutes", icon: Rocket, color: "bg-sky text-white" },
  century_club: { label: "Century Club", desc: "100 correct answers", icon: Award, color: "bg-leaf text-white" },
  consistent: { label: "Consistent", desc: "Complete 5 exercises", icon: BookOpen, color: "bg-ink text-white" },
};

export function BadgePill({ id }) {
  const b = BADGES[id];
  if (!b) return null;
  const Icon = b.icon;
  return (
    <div data-testid={`badge-${id}`} title={b.desc} className="inline-flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-full bg-white border-2 border-cloud font-bold text-sm text-ink">
      <span className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${b.color}`}>
        <Icon className="w-3.5 h-3.5" />
      </span>
      {b.label}
    </div>
  );
}
